import Modal from '../../../components/Modal';
import * as T from '../../../components/Typography';
import { BasicButton } from '../../../components/Button';

const FailModal = ({
  visible,
  buttonLabel,
  onClickButton,
  to,
  setVisible,
  coachesInvites,
}) => {
  const { failedInvites = [] } = coachesInvites || {};
  return (
    <Modal visible={visible} setIsModalVisible={setVisible}>
      <T.H1 mb={4} color="quaternaryLight">
        ERROR!
      </T.H1>
      <T.P mb={3} color="quaternaryLight">
        {failedInvites[0]?.email || ''}{' '}
        {failedInvites[0]?.error || 'Something went wrong'}
      </T.P>
      <T.P mb={3} color="quaternaryLight">
        No invitation has been sent. Please check the coach’s details and try
        again.
      </T.P>
      <BasicButton to={to} handleClick={onClickButton} variant="secondary">
        <T.P color="neutralSurface" weight="bold">
          {buttonLabel}
        </T.P>
      </BasicButton>
    </Modal>
  );
};

export default FailModal;
